import { SearchState } from '../state'
import { SearchStateManager } from '../types'
import useSearchStateLocal from './useSearchStateLocal'
import useSearchStateParams from './useSearchStateParams'

/**
 * Determines which state manager functionality to use, and returns the
 * appropriate state management utility to the useSearch function.
 *
 * @param defaultState default state to use if no key found in current search state
 * @returns the resolved search state and a function to update it (merged updates)
 */
export const useSearchState = (
  defaultState: SearchState,
  shouldPersist: boolean,
): SearchStateManager => {
  const paramsStateManager = useSearchStateParams(defaultState)
  const localStateManager = useSearchStateLocal(defaultState)

  if (shouldPersist) {
    return paramsStateManager
  } else {
    return localStateManager
  }
}
